import {
  TeamDisplayData,
  TenantMemberDisplayData,
  TenantMemberOrTeamDisplayData,
} from '@kudos/http-client'
import TeamAvatar from '@shared/avatar/TeamAvatar'
import { isTenantMemberDisplayData } from '@shared/avatar/useAvatarConfig'
import UserAvatar from '@shared/avatar/UserAvatar'
import { generateTeamName } from '@shared/forms/teamsAutoComplete/utils'
import { fullNameFromParts } from '@shared/utils/nameFormatting'
import { ReactElement } from 'react'

export const getRecipientAvatar = (member: TenantMemberOrTeamDisplayData): ReactElement => {
  const isTenantMember = isTenantMemberDisplayData(member)
  return !isTenantMember ? (
    <TeamAvatar avatarBoxStyle={{ display: 'flex' }} size={25} />
  ) : (
    <UserAvatar
      size={25}
      tenantMemberId={member?.id}
      firstName={member.firstName}
      lastName={member.lastName}
      media={member.avatarUrls}
      avatarBoxStyle={{ display: 'flex' }}
    />
  )
}

export const getRecipientChipLabel = (recipient: TenantMemberOrTeamDisplayData): string => {
  if ('activeMemberCount' in recipient) {
    const team = recipient as TeamDisplayData
    return `${generateTeamName(team.name, team.segmentType)} (${team.activeMemberCount})`
  }
  if (!isTenantMemberDisplayData(recipient)) {
    return (recipient as TeamDisplayData).name
  }
  const tenantMember = recipient as TenantMemberDisplayData
  return fullNameFromParts(tenantMember.firstName, tenantMember.lastName)
}
